import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import Description from "@/shared/components/report-template/presentation/components/common/Description";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import { generateLandSuitabilityClassParagraphs } from "@/features/reports/presentation/components/cropping-suitability-multi-product/utils/landSuitabilityClass";
// @ts-ignore
import image from "@assets/images/cropping-suitability/land-suitability-class.png";

interface HelpLandSuitabilityClassProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
}

const HelpLandSuitabilityClass = ({
  croppingSuitabilityReports,
}: HelpLandSuitabilityClassProps) => {
  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={3}>
      <div className="w-full flex flex-col gap-6">
        <Title> راهنمای کلاس‌های تناسب اراضی</Title>

        <div className="w-full flex justify-center items-center">
          <div className="w-full ">
            <img className="w-full h-full" src={image} alt="definition" />
          </div>
        </div>

        <div className="w-full flex flex-col gap-2">
          <Title>ارزیابی تناسب کشت برای محصولات مختلف به‌صورت زیر است:</Title>
          {generateLandSuitabilityClassParagraphs(
            croppingSuitabilityReports
          ).map((paragraph) => (
            <Description>{paragraph}</Description>
          ))}
        </div>
      </div>
    </ReportTemplate>
  );
};

export default HelpLandSuitabilityClass;
